import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage } from 'core/yup';

// Required only when a number is stored, so a supplier-only fix on a blank VQ can still save.
export const vendorQuoteMainInfoSchema = (isQuoteNumberRequired = true) =>
  yup.object({
    externalNumber: isQuoteNumberRequired
      ? yup
          .string()
          .trim()
          .label(t('labelVendorQuoteNumber'))
          .nullable()
          .required(getEmptyErrorMessage(t('labelVendorQuoteNumber')))
      : yup.string().trim().label(t('labelVendorQuoteNumber')).nullable(),
    revisionNumber: yup.string().trim().label(t('labelQuoteRevision')).nullable(),
    vendorLocation: yup.object().label(t('labelVendor')).nullable(),
  });
